<h2>ORGANIZZAZIONE</h2>
<p>
	Di seguito l'organizzazione di De Componendis Cifris APS e dei suoi organi direttivi. In fondo è possibile 
	vederle anche per date passate.
</p>
<h3>CONSIGLIO DIRETTIVO</h3>
<ul>
	<li>Prof. Massimiliano SALA</li>
	<li>Ing. Gianandrea GELPI</li>
	<li>Dott.ssa Michela IEZZI</li>
	<li>Prof. Ludovic PERRET</li>
	<li>Prof.ssa Elena Ivanova ANDREEVA</li>
</ul>

<h4>PRESIDENTE</h4>
<p>
	Chiar.mo Professore Massimiliano SALA
</p>

<h4>VICEPRESIDENTE</h4>
<p>
	Chiar.mo Professore Ludovic PERRET
</p> 

<h4>COLLEGIO DEI PROBIVIRI</h4>
<ul>
	<li>Prof. Antonino ALì</li>
	<li>Dott. Edoardo FABRIS</li>
	<li>Prof. Vincenzo VESPRI</li>
</ul>

<h4>TESORIERE</h4>
	<p>
		Ingegner Gianandrea GELPI
	</p>

<h4>CONSIGLIERE</h4>
<ul>
	<li>Dottoressa Michela IEZZI</li>
	<li>Professoressa Elena Ivanova ANDREEVA</li>
</ul>

<h4>COMITATO SCIENTIFICO</h4>
<ul>
	<li>Chiar.mo Prof. Marco PEDICINI – Direttore Scientifico</li>
	<li>Prof. Marco BALDI – Vicedirettore Scientifico</li>
	<li>Prof. Antonino ALì</li>
	<li>Prof. Carlo BLUNDO</li>
	<li>Prof. Andrea BRACCIALI</li>
	<li>Prof. Massimo CACCIA</li>
	<li>Dott. Roberto CIVINO</li>
	<li>Dott.ssa Claudia DE LAZZARI</li>
	<li>Dott. Leonardo ERRATI</li>
	<li>Prof.ssa Delaram KAHROBAEI</li>
	<li>Dott.ssa Carla MASCIA</li>
	<li>Prof. Alessandro NERI</li>
	<li>Prof. Gerardo PELOSI</li>
	<li>Prof.ssa Simona SAMARDJISKA</li>
	<li>Prof. Andrea VISCONTI</li>
</ul>

<hr><!------------------------------------------->
<details>
	<summary>
		Organizzazione uscente
	</summary>
	<h3>CONSIGLIO DIRETTIVO</h3>
<ul>
	<li> Sig.ra Elisa CERMIGNANI </li>
	<li> Dott. Sandro FONTANA </li>
	<li> Prof. Giuseppe MARINO </li>
	<li> Prof. Silvio RANISE </li>
	<li> Prof. Massimiliano SALA </li>
</ul>

<h4>PRESIDENTE</h4>
<p>
	Chiar.mo Professore Massimiliano SALA
</p>

<h4>VICEPRESIDENTE</h4>
<p>
	Chiar.mo Professore Giuseppe MARINO
</p>

<h4>COLLEGIO DEI PROBIVIRI</h4>
<ul>
	<li>Prof. Antonino ALì</li>
	<li>Dott. Edoardo FABRIS</li>
	<li>Prof. Vincenzo VESPRI</li>
</ul>

<h4>COMITATO SCIENTIFICO</h4>
<ul>
	<li>Chiar.mo Prof. Carlo BLUNDO – Direttore Scientifico</li>
	<li>Prof. Marco PEDICINI – ViceDirettore Scientifico</li>
	<li>Prof. Antonino ALì</li>
	<li>Prof. Riccardo ARAGONA</li>
	<li>Prof. Marco BALDI</li>
	<li>Dott. Matteo BOCCHI</li>
	<li>Prof. Andrea BRACCIALI</li>
	<li>Dott.ssa Claudia DE LAZZARI </li>
	<li>Ing. Andrea GELPI</li>
	<li>Avv. Andrea MONTI</li>
	<li>Dott. Guglielmo MORGARI</li>
	<li>Prof.ssa Fernanda PAMBIANCO</li>
	<li>Prof. Gerardo PELOSI</li>
	<li>Prof. Andrea VISCONTI</li>
</ul>
</details>

<hr><!------------------------------------------->
<details>
	<summary>
		Organizzazione precedente
	</summary>
	<br>
	<h4>CONSIGLIO DIRETTIVO</h4>
	<ul>
		<li> Sig.ra Elisa CERMIGNANI </li>
		<li> Dott. Sandro FONTANA </li>
		<li> Prof. Massimo GIULIETTI </li>
		<li> Prof. Nicola LAURENTI </li>
		<li> Prof. Massimiliano SALA </li>
	</ul>

	<h4>PRESIDENTE</h4>
	<p>
		Chiar.mo Professore Massimiliano SALA
	</p>

	<h4>VICEPRESIDENTE</h4>
	<p>
		Chiar.mo Professore Massimo GIULIETTI
	</p>
	<!-- <h4>DECANO DEI PROBIVIRI</h4>
					<p> 
						Chiar.mo Professore Vincenzo VESPRI.
					</p> -->
	<h4>COLLEGIO DEI PROBIVIRI</h4>
	<ul>
		<li> Dott.ssa Chiara BALLARI </li>
		<li> Dott. Edoardo FABRIS </li>
		<li> Chiar.mo Professore Vincenzo VESPRI </li>
	</ul>

	<h4>TESORIERE</h4>
	<p>
		Sig.ra Elisa CERMIGNANI
	</p>
</details>


<hr><!------------------------------------------->
<details>
	<summary>
		Organizzazione fondatrice
	</summary>
	<br>
	<h4>SOCI FONDATORI</h4>
	<ul>
		<li> Riccardo ARAGONA </li>
		<li> Marco BALDI </li>
		<li> Chiara Letizia BALLARI </li>
		<li> Alessandro BARENGHI </li>
		<li> Danilo BAZZANELLA </li>
		<li> Carlo BLUNDO </li>
		<li> Andrea BRACCIALI </li>
		<li> Marco CALDERINI </li>
		<li> Paolo CAMPEGIANI </li>
		<li> Luca CASATI </li>
		<li> Elisa CERMIGNANI </li>
		<li> Franco CHIARALUCE </li>
		<li> Roberto CIVINO </li>
		<li> Davide COSTA </li>
		<li> Alessandro DE PICCOLI </li>
		<li> Edoardo FABRIS </li>
		<li> Fabio FIORI </li>
		<li> Sandro FONTANA </li>
		<li> Tommaso GAGLIARDONI </li>
		<li> Norberto GAVIOLI </li>
		<li> Gianandrea GELPI </li>
		<li> Massimo GIULIETTI </li>
		<li> Roberto LA SCALA </li>
		<li> Nicola LAURENTI </li>
		<li> Alberto Ottavio LEPORATI </li>
		<li> Giuseppe MARINO </li>
		<li> Luca MARIOT </li>
		<li> Alessio MENEGHETTI </li>
		<li> Filippo MIGNOSI </li>
		<li> Guglielmo MORGARI </li>
		<li> Nadir MURRU </li>
		<li> Lorenzo NICOLODI </li>
		<li> Marco PEDICINI </li>
		<li> Gerardo PELOSI </li>
		<li> Federico PINTORE </li>
		<li> Silvio RANISE </li>
		<li> Mario RASO </li>
		<li> Denis ROIO </li>
		<li> Giuseppe ROSELLI </li>
		<li> Massimiliano SALA </li>
		<li> Paolo SANTINI </li>
		<li> Giovanni SCHMID </li>
		<li> Marco TIMPANELLA </li>
		<li> Antonio TORTORA </li>
		<li> Massimiliano VEGNI </li>
		<li> Giacomo VERTICALE </li>
		<li> Vincenzo Riccardo VESPRI </li>
		<li> Irene VILLA </li>
		<li> Filippo ZATTI </li>
		<li> Ferdinando ZULLO </li>
		<li> Roberto ZUNINO </li>
	</ul>

	<h4>SOCI BENEMERITI</h4>
	<ul>
		<li> Paolo BONAVOGLIA </li>
		<li> Emanuele CESENA </li>
		<li> Ilaria CHILLOTTI </li>
		<li> Michela IEZZI </li>
		<li> Edoardo PERSICHETTI </li>
		<li> Giancarlo RINALDO </li>
		<li> Francesco SICA </li>
		<li> Daniele VENTURI </li>
		<li> Andrea VISCONTI </li>
	</ul>
</details>
